import React from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Container, ExportWrapper, HeadingText, NftDetails, NftDetailsWrapper, NftHeadingContainer, Root } from './TableStyle'

const Year = () => {
  return (
    <Root>
    {/* <ExportWrapper>
      <ReactHtmlTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button"
        table="table-to-xls"
        filename="tablexls"
        sheet="tablexls"
        buttonText="Export"
      
      />
    </ExportWrapper> */}
    <Container id="table-to-xls">
      <NftHeadingContainer>
        <HeadingText>Date</HeadingText>
        <HeadingText>Sold</HeadingText>
        <HeadingText>Auctioned</HeadingText>
        <HeadingText>Royality</HeadingText>
        <HeadingText>Transaction Fees</HeadingText>
      </NftHeadingContainer>

      <NftDetailsWrapper>
        <NftDetails> 18/05/2023 </NftDetails>
        <NftDetails> Alien Gun </NftDetails>
        <NftDetails> Rare </NftDetails>
        <NftDetails>$200</NftDetails>
        <NftDetails>$40</NftDetails>
      </NftDetailsWrapper>
    </Container>
  </Root>
  )
}

export default Year